import { render, staticRenderFns } from "./dropdown-actions.vue?vue&type=template&id=670c62ec"
import script from "./dropdown-actions.vue?vue&type=script&lang=js"
export * from "./dropdown-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports